// extracted by mini-css-extract-plugin
module.exports = {"button":"RTEButton-button-45f6da4988b793c4aae5b6d948e06a33"};